import { useEffect, useState } from "react";
import Logo from "@assets/images/logo.png";
import modules from "@/config/module";
import SidebarItem from "../extra/layouts/SidebarItem";
import { useLocation } from "react-router-dom";

export default function Sidebar() {
  let { pathname } = useLocation();
  const [routedPath, setRoutedPath] = useState(pathname);

  useEffect(() => {
    setRoutedPath(pathname);
  }, [pathname]);

  return (
    <div className="w-80 bg-white border-r flex flex-col shadow-sm min-h-screen">
      {/* Logo */}
      <div className="flex items-center px-6 py-6 space-x-2">
        <img src={Logo} />
      </div>

      {/* Menu */}
      <nav className="flex-1 space-y-3 px-4">
        {modules.map((module) => (
          <SidebarItem
            routedPath={routedPath}
            setRoutedPath={setRoutedPath}
            key={module.id}
            mainModule={module}
          />
        ))}
      </nav>
    </div>
  );
}
